import { createVuetify } from 'vuetify';
import { VCalendar } from 'vuetify/labs/VCalendar';
import { aliases, mdi } from 'vuetify/iconsets/mdi-svg';
import { icons } from './mdi-icon'; // Import icons from separate file
import * as components from 'vuetify/components';
import * as directives from 'vuetify/directives';
import { uk, en } from 'vuetify/locale';
import {
  DefaultTheme,
  LightTheme1,
  LightTheme2,
  LightTheme3,
  LightTheme4,
  LightTheme5,
  LightTheme6,
  LightTheme7,
  LightTheme8,
} from '@/theme/LightTheme';
import {
  DarkDefaultTheme,
  DarkTheme1,
  DarkTheme6,
  DarkTheme7,
  DarkTheme8,
  DarkTheme5,
  DarkTheme2,
  DarkTheme3,
  DarkTheme4,
} from '@/theme/DarkTheme';

export default createVuetify({
  components: {
    ...components,
    VCalendar,
  },

  directives,
  icons: {
    defaultSet: 'mdi',
    aliases: {
      ...aliases,
      ...icons,
    },
    sets: {
      mdi,
    },
  },
  theme: {
    defaultTheme: 'DefaultTheme',
    themes: {
      DefaultTheme,
      LightTheme1,
      LightTheme2,
      LightTheme3,
      LightTheme4,
      LightTheme5,
      LightTheme6,
      LightTheme7,
      LightTheme8,
      DarkDefaultTheme,
      DarkTheme1,
      DarkTheme8,
      DarkTheme7,
      DarkTheme6,
      DarkTheme5,
      DarkTheme2,
      DarkTheme3,
      DarkTheme4,
    },
  },

  locale: {
    messages: { uk, en },
  },

  defaults: {
    VBtn: {
      height: '40px',
    },
    VCard: {
      rounded: 'md',
    },
    VTextField: {
      rounded: 'lg',
      height: '40px',
    },
    VTooltip: {
      // set v-tooltip default location to top
      location: 'top',
    },
  },
});
